// extracted by mini-css-extract-plugin
export default {"invoiceRow":"DKDuCQjNFtu8f7t99r7y","actionCell":"RCTcOl6Efh0do2fiI_6a"};